/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForCostCenterAws extends models.ServiceAccountNativeDetailsBaseForCostCenterCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForCostCenterAws");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForCostCenterAws.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForCostCenterAws>): ServiceAccountNativeDetailsForCostCenterAws {
        let obj = Object.assign(new ServiceAccountNativeDetailsForCostCenterAws(), model);
        ServiceAccountNativeDetailsForCostCenterAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForCostCenterAws>): ServiceAccountNativeDetailsForCostCenterAws {
        if (!model) return null;
        return ServiceAccountNativeDetailsForCostCenterAws.newInstance(<ServiceAccountNativeDetailsForCostCenterAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForCostCenterAws) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForCostCenterAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForCostCenterAws): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCostCenterCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForCostCenterAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant Id
     */
    tenant_id: string;

}
